import React from 'react';
// import Header from './Header';
// import Footer from './Footer';

const Services = () => {
  return (
    <>
      {/* <Header /> */}
      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
        {/* <div className="breadcumb-wrapper" data-bg-src="assets/img/hero/slider1.jpg"> */}
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Services </h1>
          </div>
        </div>
      </div>
      <section className="bg-theme overflow-hidden space overflow-hidden" data-bg-src="assets/img/bg/event-shape.html">
        <div className="container">

          <div className="row gy-4 gx-40">

            <div className="col-12">
              <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                <div className="box-wrapper">
                  <div className="box-wrapp">
                    <div className="num">
                      <h2 className="box-number">01</h2>
                    </div>
                    <div className="box-content">
                      <h3 className="box-title">
                        <a href="#">GOSAMRAKSHANA (COW PROTECTION PROGRAM) </a>
                      </h3>
                      <p className="box-text">
                        The Vedic tradition respects and worships every cow as the universal Mother Goddess. Taking good care of cows
                        is believed to immensely please the Supreme. Moreover, every product from the cow - the Go-Mutra (cow’s
                        urine), cow dung, cow milk, etc possess religious significance as well as high medicinal properties. But, sadly, in
                        recent times, cows that are meant to be worshipped and revered are cruelly slaughtered. The increasing rate of
                        cow slaughter and beef export is a very depressing and shocking truth prevailing in the present days.
                        Hence, to protect and nourish cows, Sreemath Hariharapura conducts Cow Protection Programmes at many places in and around
                        South India. Volunteers from Sreemath campaign against cow slaughter, creating awareness among people about the need to
                        protect cows. Plans are on to set up Goshalas at various locations, where cows can be protected and nourished in the best
                        possible manner. Presently, there is a Goshala at Hariharapura, called the “Brindaavana Goshaala”, where cows
                        whether barren or old, young or milking, calves or infants - ALL are nourished and taken care under best medical facilities. Presently there
                        are about 100 cows in this Goshala.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="box-img global-img">
                  <img src="assets/img/event/services/1.jpg" alt="event" />
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                <div className="box-wrapper">
                  <div className="box-wrapp">
                    <div className="num">
                      <h2 className="box-number">02</h2>
                    </div>
                    <div className="box-content">
                      <h3 className="box-title">
                        <a href="#">VEDA PATASHALA </a>
                      </h3>
                      <p className="box-text">
                        Preserving Vedic knowledge is very important in securing universal welfare and peace. The Vedapatashala at
                        Hariharapura, an exclusive residential school with modern amenities, educates young Brahmacharis in Sanskrit,
                        Veda-Sastras along with basic-modern education/computer skills.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="box-img global-img">
                  <img src="assets/img/event/services/2.jpg" alt="event" />
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                <div className="box-wrapper">
                  <div className="box-wrapp">
                    <div className="num">
                      <h2 className="box-number">03</h2>
                    </div>
                    <div className="box-content">
                      <h3 className="box-title">
                        <a href="#">EDUCATIONAL INSTITUTIONS </a>
                      </h3>
                      <p className="box-text">
                        Sreemath runs schools and colleges at many villages in Karnataka. Very nominal fee is charged in these
                        institutions. Free education is also provided to children who are from financially backward families. <br />
                        -SRI SACHIDANANDA SARAWATHI INSTITUTION, a High school at Hariharapura, Karnataka <br />
                        -SRI RAMANANDA SARASWATHI PU COLLEGE (Pre-University College) at Hariharapura, Karnataka <br />
                        -SWAYAMPRAKASHA SAMSTE, a school at Narve, Karnataka <br />
                        -SRI RAMANANDA SARASWATHI HIGH SCHOOL at Kigga, Karnataka <br />
                        are few education institutions run by Sreemath for the past 60 Years.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="box-img global-img">
                  <img src="assets/img/event/services/3.jpg" alt="event" />
                </div>
              </div>
            </div>



            <div className="col-12">
              <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                <div className="box-wrapper">
                  <div className="box-wrapp">
                    <div className="num">
                      <h2 className="box-number">04</h2>
                    </div>
                    <div className="box-content">
                      <h3 className="box-title">
                        <a href="#">ANNADANAM (FREE FOOD FOR ALL) </a>
                      </h3>
                      <p className="box-text">
                        Everyday, Annadanam (free food) is provided for around 500 and more people at the premises of Sreemath
                        Hariharapura. To feed more and more people in future, “Sri Lakshmi Narasimha Prasada Mandiram” – a large
                        modern kitchen with dining facility to accommodate around 2000 people at a time is presently on construction.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="box-img global-img">
                  <img src="assets/img/event/services/4.jpg" alt="event" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
};

export default Services;
